import { render } from "./EditSubject.vue?vue&type=template&id=005cb60d"
import script from "./EditSubject.vue?vue&type=script&lang=js"
export * from "./EditSubject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__